<template>
    <div>
        <Info></Info>
    </div>
</template>

<script>
import Info from '@/components/layout/Info'
export default {
    name: 'layout-header',
    data () {
        return {

        }
    },
    components: {
        Info
    }
}
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/page/layout/Header.vue